import { createAsyncThunk } from "@reduxjs/toolkit";
import { send } from "../../app/appSlice";
import { AppThunkApi } from "../../app/store";
import { AnaylseData, DataAnaylseValue } from "../../models/Anaylse";
import * as S from "../../services/HealthPrisonAnaylse";
import { HealthPrisonContrastParams } from "../../services/HealthPrisonAnaylse";

//监管数据占比-卫健委(局)
export const getHealthPrisonAnaylseData = createAsyncThunk<
    AnaylseData[],
    HealthPrisonContrastParams,
    AppThunkApi
>("HealthPrison/getAnaylseData", async (params, api) => {
    return send(S.getHealthPrisonAnaylse(params), api);
});

// 监管数据对比 - 卫健委(局)
export const getDataAnaylseData = createAsyncThunk<
    DataAnaylseValue[],
    S.DataParams,
    AppThunkApi
>("HealthPrison/getDataAnaylse", async (params, api) => {
    return send(S.getDataAnaylse(params), api);
});

// 监管数据变化 - 卫健委(局)
export const getHealthPrisonContrastData = createAsyncThunk<
    AnaylseData[],
    S.HealthPrisonAnaylseParams,
    AppThunkApi
>("HealthPrison/getContrastData", async (params, api) => {
    return send(S.getHealthPrisonContrast(params), api);
});